/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable jsx-a11y/anchor-has-content */

import React from 'react'
import { v4 as rid } from 'uuid'
import { CONTAINER_TITLE } from '../constants/enum'

const NavigationDots = ({ activeContainer }) => (
  <div className="app__navigation">
    {CONTAINER_TITLE.map(item => (
      <a
        href={`#${item}`}
        tabIndex={-1}
        key={`nav_${rid()}`}
        className="app__navigation-dot"
        style={activeContainer === item ? { backgroundColor: '#313BAC' } : {}}
      />
    ))}
  </div>
)
export default NavigationDots
